const analytics = {
  logEvents: process.env.NEXT_PUBLIC_ANALYTICS_LOGGING === 'true',
};

export default { analytics };
